import { render, staticRenderFns } from "./ViewCoachScoutingReport.vue?vue&type=template&id=47ab0ba3&scoped=true&"
import script from "./ViewCoachScoutingReport.vue?vue&type=script&lang=ts&"
export * from "./ViewCoachScoutingReport.vue?vue&type=script&lang=ts&"
import style0 from "./ViewCoachScoutingReport.vue?vue&type=style&index=0&id=47ab0ba3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ab0ba3",
  null
  
)

export default component.exports